import { NFTContractContext } from '@contexts/NFTContractContext'
import { useContext } from 'react'

const useMyNFT = () => useContext(NFTContractContext)

export default useMyNFT
